var _defs, _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgModalClose = function SvgModalClose(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 36.36 35.14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".corporate-cross-1,.corporate-cross-2,.corporate-cross-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.corporate-cross-1{stroke:url(#radial-gradient);}.corporate-cross-2{stroke:url(#radial-gradient-2);}.corporate-cross-3{stroke:url(#radial-gradient-3);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -249.61,
    cy: 588.62,
    r: 1,
    gradientTransform: "matrix(130.5, 112, 111.09, -129.44, -32844.53, 104121.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f11e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10015"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -248.07,
    cy: 590.34,
    gradientTransform: "matrix(-40.83, 31.67, 31.67, 40.83, -28784.92, -16244.33)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -249.58,
    cy: 587.45,
    gradientTransform: "matrix(54.17, 28.33, 28.33, -54.17, -3121.47, 38902.68)",
    xlinkHref: "#radial-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "corporate-cross-1",
    d: "M18.1,32.46c8.77,0,16-6.65,16-15s-7.23-15-16-15-16,6.66-16,15S9.33,32.46,18.1,32.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-cross-2",
    d: "M23.1,12.46l-10,10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-cross-3",
    d: "M13.1,12.46l10,10"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModalClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modalClose.a522f857.svg";
export { ForwardRef as ReactComponent };